import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {renderRoutes} from '@computerrock/formation-router';
import {AppLayout, AppLayoutMain, AppLayoutFooter, useStyles} from '@ace-de/ui-components';
import '@ace-de/ui-components/index.module.scss';
import config from '../config';

const ApplicationScreen = ({route}) => {
    const {cx} = useStyles();
    return (
        <AppLayout>
            <AppLayoutMain>
                {renderRoutes(route.routes)}
            </AppLayoutMain>
            <AppLayoutFooter>
                <div
                    data-qa="app-footer-version"
                    className={cx([
                        'global!ace-u-margin--top-8',
                        'global!ace-u-typography--variant-body',
                        'global!ace-u-typography--color-disabled',
                        'global!ace-u-pointer-events--auto',
                    ])}
                >
                    Version: {config.VERSION} Build: {config.BUILD}
                </div>
            </AppLayoutFooter>
        </AppLayout>
    );
};

ApplicationScreen.propTypes = {
    route: PropTypes.object.isRequired,
    // someStateValue: PropTypes.object,
};

ApplicationScreen.defaultProps = {
    // no-op
    // someStateValue: null,
};

const mapStateToProps = state => ({
    // no-op
    // someStateValue: state.domain.someStateValue
});

const mapDispatchToProps = dispatch => ({
    // no-op
    // callAction: payload => dispatch({
    //     type: someActionTypes.CALL_ACTION,
    //     payload,
    // }),
});

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationScreen);
